<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert type="info" show-icon style="margin-bottom: 24px" message="提现规则说明">
        <template slot="description">
          <div>App 用户提现前会读取本配置，用于展示手续费、计算实际到账，并校验最低提现金额。</div>
          <div style="margin-top: 4px">关闭「启用手续费」后，提现不再扣除手续费（feeRate 仍保留供下次开启使用）。</div>
        </template>
      </a-alert>

      <a-spin :spinning="loading">
        <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item label="启用手续费">
            <a-switch
              :checked="form.feeEnabled === 1"
              checked-children="是"
              un-checked-children="否"
              @change="onFeeEnabledChange"
            />
          </a-form-model-item>

          <a-form-model-item v-if="form.feeEnabled === 1" label="手续费率 (%)" required>
            <a-input-number
              v-model="form.feeRatePercent"
              :min="0.01"
              :max="100"
              :step="0.01"
              :precision="2"
              style="width: 240px"
            />
            <div class="form-tip">例如 1 表示收取 1% 手续费；实际到账 = 提现金额 × (1 - 费率%)</div>
          </a-form-model-item>

          <a-form-model-item label="最低提现金额" required>
            <a-input-number
              v-model="form.minAmount"
              :min="0"
              :step="1"
              :precision="2"
              style="width: 240px"
            />
            <div class="form-tip">用户提现金额须 ≥ 此值，否则 App 提交会被拒绝</div>
          </a-form-model-item>

          <a-form-model-item v-if="form.feeEnabled === 1 && previewAmount > 0" label="示例计算">
            <div class="preview-box">
              <div>提现 {{ previewAmount }}，手续费 {{ previewFee }}，实际到账 {{ previewActual }}</div>
            </div>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
            <a-button type="primary" :loading="submitLoading" @click="submitForm">保存配置</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getWithdrawConfig, saveWithdrawConfig } from '@/api/giftcard/withdrawConfig'

export default {
  name: 'GiftcardWithdrawConfig',
  data() {
    return {
      loading: false,
      submitLoading: false,
      previewAmount: 1000,
      form: {
        feeEnabled: 1,
        feeRatePercent: 1,
        minAmount: 100
      }
    }
  },
  computed: {
    previewFee() {
      if (this.form.feeEnabled !== 1 || !this.form.feeRatePercent) return 0
      return Number((this.previewAmount * this.form.feeRatePercent / 100).toFixed(2))
    },
    previewActual() {
      return Number((this.previewAmount - this.previewFee).toFixed(2))
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.loading = true
      getWithdrawConfig().then(res => {
        const data = res.data || {}
        this.form = {
          feeEnabled: data.feeEnabled == null ? 0 : data.feeEnabled,
          feeRatePercent: data.feeRatePercent != null ? Number(data.feeRatePercent) : 1,
          minAmount: data.minAmount != null ? Number(data.minAmount) : 100
        }
      }).finally(() => { this.loading = false })
    },
    onFeeEnabledChange(checked) {
      this.form.feeEnabled = checked ? 1 : 0
    },
    submitForm() {
      if (this.form.minAmount == null || this.form.minAmount < 0) {
        this.$message.warning('请填写有效的最低提现金额')
        return
      }
      if (this.form.feeEnabled === 1) {
        if (!this.form.feeRatePercent || this.form.feeRatePercent <= 0) {
          this.$message.warning('启用手续费时请填写大于0的费率')
          return
        }
      }
      const payload = {
        feeEnabled: this.form.feeEnabled,
        feeRatePercent: this.form.feeRatePercent,
        minAmount: this.form.minAmount
      }
      this.submitLoading = true
      saveWithdrawConfig(payload).then(() => {
        this.$message.success('保存成功')
        this.loadConfig()
      }).finally(() => { this.submitLoading = false })
    }
  }
}
</script>

<style scoped>
.form-tip { color: rgba(0, 0, 0, 0.45); font-size: 12px; margin-top: 4px; }
.preview-box { color: rgba(0, 0, 0, 0.65); font-size: 13px; }
</style>
